export type Stage =
  "to_do" | "in_progress" | "ready_for_collection" | "billing" | "done";
export type Job = {
  id: string;
  revision: string;
  customer_id: string;
  vehicle_id: string;
  assignee_id: string;
  current_staff: { id: string; name: string }[];
  helper_ids: string[];
  work_state: Stage | "cancelled" | "no_show";
  advance_overdue?: boolean;
  payment_received_minor: string;
  billing_total_minor: string;
  outstanding_minor: string;
  collected_at: string | null;
  arrived_at: string | null;
  completed_at: string | null;
  done_at: string | null;
  cancelled_at: string | null;
  cancellation_reason: string | null;
  billing_assignee_id: string | null;
  capacity: {
    state: "hold" | "confirmed" | "in_progress" | "released" | "expired";
    started_at: string | null;
    released_at: string | null;
  };
  starts_at: string;
  ends_at: string;
  time_zone: string;
  bay_name: string;
  representation: {
    customer: { name: string; email: string | null; phone: string | null };
    vehicle: {
      make: string;
      model: string;
      fabrication_year: number | null;
      registration_number: string | null;
    };
    staff: { id: string; name: string }[];
    total: {
      currency: string;
      net_minor: string;
      tax_minor: string;
      total_minor: string;
      lines: {
        line_id: string;
        name: string;
        description: string | null;
        quantity: number;
        unit_price_minor: string;
        total_minor: string;
        tax_label: string | null;
      }[];
    };
  };
};

export function money(
  minor: number | string,
  currency: string,
  locale: string,
) {
  const amount = BigInt(minor);
  const absolute = amount < 0n ? -amount : amount;
  const whole = absolute / 100n;
  const signed = amount < 0n ? (whole === 0n ? -0 : -whole) : whole;
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
    .formatToParts(signed)
    .map((part) =>
      part.type === "fraction"
        ? String(absolute % 100n).padStart(2, "0")
        : part.value,
    )
    .join("");
}

export function dateTime(value: string, zone: string, locale: string) {
  return new Intl.DateTimeFormat(locale, {
    dateStyle: "medium",
    timeStyle: "short",
    timeZone: zone,
  }).format(new Date(value));
}
